import { render, staticRenderFns } from "./salaryTemplate.vue?vue&type=template&id=689e3742&scoped=true&"
import script from "./salaryTemplate.vue?vue&type=script&lang=js&"
export * from "./salaryTemplate.vue?vue&type=script&lang=js&"
import style0 from "./salaryTemplate.vue?vue&type=style&index=0&id=689e3742&scoped=true&lang=css&"
import style1 from "./salaryTemplate.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689e3742",
  null
  
)

export default component.exports